import { useLayoutEffect, useState } from "react";
import { bugsnagClient } from "./bugsnag";
import { isProd } from "./env";

export const PORTAL_ROOT_ID = "portal-root";
export default function PortalRoot() {
  return <div id={PORTAL_ROOT_ID} />;
}

function queryRoot() {
  return document.getElementById(PORTAL_ROOT_ID);
}
export const usePortalRoot = () => {
  const [root, setRoot] = useState<HTMLElement | null>(queryRoot());

  useLayoutEffect(() => {
    if (!root) {
      const result = queryRoot();
      if (!result) {
        if (isProd) {
          bugsnagClient?.notify("Could not find portal root");
        } else {
          throw new Error(
            "Portal root element not found, make sure to render `PortalRoot` or decorate story with `portalDecorator`"
          );
        }
      }
      setRoot(result);
    }
  }, [root]);

  return root;
};
